<script>
import Loader from "./loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  data() {
    return { 
      TableData: {},
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    }
  },
  components: {
    Loader,
  },
  props: {
    updating: {
      type: Boolean,
    },
  },
  methods:{
    Get() {  
      this.ActionsGet({"Service":"ODuyuru", "Page":this.Page}).then((res) => { 
        this.TableData = res.Data; 
      });
    }
  }
};
</script>
<template>
  <Loader :loading="updating">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-5">{{this.$t('StrWidgets.ODuyuru.Title')}}</h4>
        <ul class="verti-timeline list-unstyled">
          <li class="event-list" v-for="Data in TableData" :key="Data.Id">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{ Data.IslemTarihi | formatDateTable }}
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <h5>{{ Data.Baslik }}</h5>
                <div> {{ Data.Icerik }}</div>
              </div>
            </div>
          </li> 
        </ul> 
      </div>
    </div>
  </Loader>
</template>